export default "__VITE_ASSET__B_QH2SVS__"